export default __webpack_public_path__ + "images/9936c1f3e8c50afeae4bc8492661531a-petsandanimals.webp";